export default __webpack_public_path__ + "static/media/loading-page.e0cda664.svg";